import { ShieldCheck, BadgeEuro, ScrollText } from "lucide-react";

/**
 * Bandeau de réassurance — 3 items sobres avec icônes fines.
 * Aucun faux témoignage ; strictement des engagements factuels.
 */
export default function ReassuranceBand() {
  const items = [
    { icon: ShieldCheck, title: "Prix ferme garanti au contrat", text: "Fixé à la signature notariée. Aucune révision, aucune indexation." },
    { icon: BadgeEuro, title: "0 commission · 0 frais cachés", text: "Plateforme 100 % gratuite pour vendeurs, acheteurs et agences." },
    { icon: ScrollText, title: "Signature chez notaire obligatoire", text: "Acte authentique, hypothèque légale spéciale et clause résolutoire." },
  ];
  return (
    <section aria-label="Nos engagements" className="bg-white border-y border-navy/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-8 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12">
        {items.map(({ icon: Icon, title, text }, i) => (
          <div key={i} className="flex items-start gap-4" data-testid={`reassurance-item-${i}`}>
            <div className="shrink-0 w-11 h-11 border border-accent-brand/40 flex items-center justify-center bg-accent-brand/5">
              <Icon className="text-accent-brand" size={22} strokeWidth={1.4} />
            </div>
            <div>
              <div className="font-serif text-navy text-lg leading-snug mb-1 text-balance">{title}</div>
              <div className="text-sm text-navy/65 leading-relaxed">{text}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
